import React from 'react';
import BaseScreen from '../base-screen/BaseScreen.component';
import WithButton from '../../hocs/with-button/WithButton.component';

const BaseScreenWithButton = ({children, ...props}) => {
  return <BaseScreen {...props}>{children}</BaseScreen>;
};

export default WithButton(BaseScreenWithButton);
